module.exports = __webpack_public_path__ + "img/eyezen.c1c7b880.jpg";